"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.join");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typeValidation = _interopRequireDefault(require("./typeValidation"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PctyGridHeaderRowCheckboxCell = function PctyGridHeaderRowCheckboxCell(_ref) {
  var _onChange = _ref.onChange,
      checked = _ref.checked,
      disabled = _ref.disabled,
      indeterminate = _ref.indeterminate,
      render = _ref.render,
      visible = _ref.visible,
      children = _ref.children,
      automationId = _ref.automationId,
      __disabled = _ref.__disabled,
      __TYPE = _ref.__TYPE,
      other = (0, _objectWithoutProperties2.default)(_ref, ["onChange", "checked", "disabled", "indeterminate", "render", "visible", "children", "automationId", "__disabled", "__TYPE"]);

  var getAutomation = function getAutomation(suffix) {
    return !automationId ? {} : {
      'data-automation-id': automationId + (suffix ? "-".concat(suffix) : '')
    };
  };

  var _props = _objectSpread(_objectSpread(_objectSpread({}, other), getAutomation()), {}, {
    className: ['pcty-list-checkbox', other.className || ''].filter(function (x) {
      return x.length > 0;
    }).join(' ')
  });

  if (!visible) return /*#__PURE__*/_react.default.createElement("td", _props);
  var css = !!disabled ? 'pcty-disabled' : '';

  if (!!render) {
    return /*#__PURE__*/_react.default.createElement("th", (0, _extends2.default)({
      className: "pcty-grid-header-row-checkbox-cell-th"
    }, _props), /*#__PURE__*/_react.default.createElement("input", {
      checked: checked,
      className: css,
      disabled: disabled || __disabled,
      onChange: function onChange() {
        return render(children, _onChange);
      },
      ref: function ref(input) {
        if (input && indeterminate) {
          input.indeterminate = indeterminate;
        }
      },
      type: "checkbox"
    }));
  }

  return /*#__PURE__*/_react.default.createElement("th", (0, _extends2.default)({
    className: "pcty-grid-header-row-checkbox-cell-th"
  }, _props), /*#__PURE__*/_react.default.createElement("input", {
    checked: checked,
    className: css,
    disabled: disabled || __disabled,
    onChange: _onChange,
    ref: function ref(input) {
      if (input && indeterminate) {
        input.indeterminate = indeterminate;
      }
    },
    type: "checkbox"
  }));
};

PctyGridHeaderRowCheckboxCell.propTypes = {
  /** Handles the onChange event. NOTE: When used with PctyBindableGrid, the function should have (selected) as a named param which is an array of the selected items. When used with PctyBindableGridPage, the function should have (selection) as a named param. See 'PctyBindableGridPage Checkbox Selection Info' below for more info. */
  onChange: _propTypes.default.func,

  /** Specifies the 'checked' of the checkbox */
  checked: _propTypes.default.bool,

  /** Specifies the 'indeterminate' of the checkbox */
  indeterminate: _propTypes.default.bool,

  /** Whether or not the checkbox is disabled */
  disabled: _propTypes.default.bool,

  /** Whether or not the checkbox is visible (the cell will still exist but will be empty) */
  visible: _propTypes.default.bool,

  /** Overrides the internal PctyGridRowCheckboxCell render. (see Bindable Grid example below for usage) */
  render: _propTypes.default.func,

  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes.default.string,
  __disabled: _propTypes.default.bool,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyGridHeaderRowCheckboxCell');
  }
  /** INCLUDE OTHER */

};
PctyGridHeaderRowCheckboxCell.defaultProps = {
  onChange: function onChange() {},
  checked: false,
  indeterminate: false,
  disabled: false,
  visible: true,
  __disabled: false,
  __TYPE: 'PctyGridHeaderRowCheckboxCell'
};
var _default = PctyGridHeaderRowCheckboxCell;
exports.default = _default;